namespace RedBullMOBILE360.Sms {
    export interface WhitelistImportForm {
        ListName: Serenity.StringEditor;
        FileName: Serenity.ImageUploadEditor;
    }

    export class WhitelistImportForm extends Serenity.PrefixedContext {
        static formKey = 'Sms.WhitelistImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WhitelistImportForm.init)  {
                WhitelistImportForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ImageUploadEditor;

                Q.initFormType(WhitelistImportForm, [
                    'ListName', w0,
                    'FileName', w1
                ]);
            }
        }
    }
}
